import { GamificationDetailPage } from "@Elements";
import { createRoute } from "@tanstack/react-router";
import { DashboardBaseRoute } from "./Dashboard.route";

export const GamificationRoute = createRoute({
  getParentRoute: () => DashboardBaseRoute,
  path: "/gamification",
  component: GamificationDetailPage,
  staticData: {
    TITLE: "Gamification Yönetimi",
  },
});

export const GamificationRouteTree = GamificationRoute;

const Routes = {
  Gamification: {
    GamificationRoute,
  },
};

export { Routes };
